import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListIndented12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconListIndented12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.009 1.5a.5.5 0 0 1-.5.5H4.487a.5.5 0 1 1 0-1h6.022a.5.5 0 0 1 .5.5m-1.39 3a.5.5 0 0 1-.5.5H4.487a.5.5 0 1 1 0-1h4.632a.5.5 0 0 1 .5.5m.89 3.5a.5.5 0 0 0 0-1H4.487a.5.5 0 1 0 0 1zm-.89 2.5a.5.5 0 0 1-.5.5H4.487a.5.5 0 0 1 0-1h4.632a.5.5 0 0 1 .5.5M1 1.5v9a.5.5 0 0 0 1 0v-9a.5.5 0 0 0-1 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListIndented12);
